module.exports = __webpack_public_path__ + "img/xcxt.13b7ac8e.png";